// import Serializer from "./serializer";
import AxiosConfig from '../api/axios.config';
const Mustache = require('mustache');
import axios, { AxiosInstance } from 'axios';
import Utility from '../classes/utility';

let promoBannerTemplate = require('../../templates/components/alerts/promo/top-page-banner').default;

class PromoBanners {
    axiosClient: AxiosInstance;
    infoBanner: HTMLElement;

    constructor() {
        this.axiosClient = axios.create(AxiosConfig);
        this.init();
    }

    // has the date past
    public hasPast(date: string) {
        // get the current date
        const now = new Date();
        let dateParsed = new Date(date.replace(/-/g,"/")); 
        // compare the current date to the input date
        return now > dateParsed;
    }

    init() {
        const self = this;
        
        // TODO: change link to prod domain - make a global config for axios
        this.axiosClient.get(`api/promos/promobanner`)
        .then(function (response) {
            let promoBannerTemplateRendered = "";
            
            if (response.data) {
                let data = response.data;
                if (data) {
                    if (data.promos) {
                        let removeTrailingSlash = (str) => {
                            return str.endsWith('/') ? str.slice(0, -1) : str;
                        };

                        let resizeHeader = () => {
                            const resizer = () => {
                                console.log('resized');
                            }

                            // on sitewide-banner closed
                            const sitewideBanner = document.querySelector('.sitewide-banner');
                            sitewideBanner.addEventListener('closed', (e) => {
                                resizer();
                            });

                            // function on window resize
                            window.addEventListener('resize', () => {
                                resizer();
                            }, true);
                            resizer();
                        };

                        let renderPromoFn = function(promo: any)
                        {
                            let currentUrl = window.location.href.split('?')[0];
                            let promoContainer = document.getElementById("page-promo-banner-hero-area");
                            
                            //Decode the title
                            if(promo.title)
                            {
                                promo.title = Utility.htmlDecode(promo.title);
                            }

                            // Decode the content
                            if (promo.content) {
                                promo.content = Utility.htmlDecode(promo.content);
                            }

                            if (promoContainer) {
                                promoBannerTemplateRendered = Mustache.render(promoBannerTemplate, promo);
                                if (promo.display.location == "global") {
                                    if (promo.excludePages && Array.isArray(promo.excludePages)) {
                                        promo.excludePages.forEach(excludedPage => {
                                            // Normalize paths: remove "/pages" and trailing slashes
                                            if (excludedPage !== "") {
                                                try {
                                                    const excludedPath = new URL(excludedPage.replace("/pages", "").replace("/index", ""), window.location.origin)
                                                        .pathname.replace(/\/$/, ""); // Remove trailing slash
                                                    const currentPath = new URL(location.href.replace("/index", ""), window.location.origin)
                                                        .pathname.replace(/\/$/, ""); // Remove trailing slash
                                                    // Check if the excluded path matches the current path
                                                    if (excludedPath === currentPath) {
                                                        promoBannerTemplateRendered = "";
                                                    }
                                                } catch (error) {
                                                    console.error("Error processing excludedPage:", excludedPage, error);
                                                }
                                            }
                                        });
                                    }
                                    promoContainer.innerHTML = promoBannerTemplateRendered;
                                    resizeHeader();
                                } else if (promo.display && promo.display.location == "page") {
                                    console.log("page testing for promo");
                                    let updateURl =  promo.display.selectedPage.replace("/pages", "").replace("/index", "")
                                    let urlPath = removeTrailingSlash(new URL(updateURl).pathname).split("/").pop();
                                    let currUrlPath = removeTrailingSlash(new URL(currentUrl).pathname).split("/").pop();

                                    
                                    console.log("currUrlPath", currUrlPath);
                                    console.log("urlPath", urlPath);
                                    console.log("before url");
                                    if(urlPath == currUrlPath) {
                                        promoContainer.innerHTML = promoBannerTemplateRendered;
                                        resizeHeader();
                                    } else {
                                        if(promo.display.displayOnChildren == "yes")
                                        {
                                            if(currentUrl.includes(urlPath)) {
                                                promoContainer.innerHTML = promoBannerTemplateRendered;
                                                resizeHeader();
                                            }
                                        }
                                    }
                                }
                            }
                        };

                        let promos = data.promos.promos as Array<any>;
                        promos.forEach((promo) => {
                            let startEnabled = false;
                            let endEnabled = false;
                            if (promo.scheduler.startEnabled == "yes")
                            {
                                startEnabled = true;
                            }
                            if (promo.scheduler.endEnabled == "yes")
                            {
                                endEnabled = true;
                            }
                            if (startEnabled && endEnabled) {
                                // just check start time
                                if (self.hasPast(promo.scheduler.start) && !self.hasPast(promo.scheduler.end)) {
                                    // render the alert
                                    renderPromoFn(promo);
                                }
                            } else if (startEnabled && !endEnabled) {
                                // just check start time
                                if (self.hasPast(promo.scheduler.start)) {
                                    // render the alert
                                    renderPromoFn(promo);
                                }
                            } else if (!startEnabled && endEnabled) {
                                // just check end time
                                if (!self.hasPast(promo.scheduler.end)) {
                                    // render the alert
                                    renderPromoFn(promo);
                                }
                            }
                        });
                    }
                }
            }
        })
        .catch(function (error) {
            // console.log(error);
        });
    }
}

export default PromoBanners;